export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-octree/src/root.js
// module id = 254
// module chunks = 0